import helperStyles from "@src/components/helpers.module.scss";
import useSvgFillColor from "@src/hooks/useSvgFillColor";
import React from "react";

const MinusIconThemed = () => {
	const fillColor = useSvgFillColor();

	return (
		<div className={helperStyles.iconContainer}>
			<svg width="13" height="1" viewBox="0 0 13 1" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M12.7422 0.5C12.7422 0.605672 12.7002 0.707017 12.6255 0.781738C12.5508 0.85646 12.4494 0.898438 12.3438 0.898438H0.65625C0.550578 0.898438 0.449234 0.85646 0.374512 0.781738C0.299791 0.707017 0.257813 0.605672 0.257812 0.5C0.257812 0.394328 0.299791 0.292984 0.374512 0.218262C0.449234 0.143541 0.550578 0.101562 0.65625 0.101562H12.3438C12.4494 0.101562 12.5508 0.143541 12.6255 0.218262C12.7002 0.292984 12.7422 0.394328 12.7422 0.5Z"
					fill={fillColor}
				/>
			</svg>
		</div>
	);
};

export default MinusIconThemed;
